import React, { createContext, useContext, useEffect, useState } from "react";
import { useLogout, isTokenExpired, isLoggedIn } from "../Utils/auth";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [loggedIn, setLoggedIn] = useState(false);
  const [user, setUser] = useState({});
  const [useIAP, setUseIAP] = useState(false);
  const [clientClassName, setClientClassName] = useState("");
  const logout = useLogout();

  const checkToken = () => {
    const token = localStorage.getItem("token");
    if (!token || isTokenExpired(token)) {
      setLoggedIn(false);
      logout();
    } else {
      setLoggedIn(true);
    }
  };

  useEffect(() => {
    checkToken();
    const intervalId = setInterval(() => {
      checkToken();
    }, 30 * 60 * 1000);
    return () => clearInterval(intervalId);
  }, []);


  useEffect(() => {
    setLoggedIn(isLoggedIn());
    if (isLoggedIn()) {
      const raw = localStorage.getItem("userData");
      const userData = raw ? JSON.parse(raw) : {};
      setUser(userData);
      if (Boolean(localStorage.getItem("IAP"))) {
        setUseIAP(true);
      }
    }
    if (!isLoggedIn()) {
      setUser({});
    }
  }, [loggedIn]);

  const value = { loggedIn, setLoggedIn, useLogout, user, setUser, useIAP, setUseIAP, clientClassName, setClientClassName };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
